import React from 'react'
import { formatBytes } from '@snsw-gel/utils'
import { UploadedItemContainer } from './UploadedItem.styled'
import { Button } from '@snsw-gel/button'
import classNames from 'classnames'

export interface UploadedItemProps {
    id: string
    name: string
    size: number
    onRemove: () => void
}

export const UploadedItem = (props: UploadedItemProps) => {
    const { id, name, size, onRemove } = props
    const convertSize = size && formatBytes(size, 1)

    return (
        <UploadedItemContainer
            className={classNames('uploaded-item')}
            data-testid={`${id}-file`}
        >
            <span
                data-testid={`${id}-file-info`}
                className={classNames('uploaded-item__file-info')}
            >
                {name}{' '}
                <span className={classNames('uploaded-item__file-size')}>
                    ({convertSize})
                </span>
            </span>
            <div className={classNames('uploaded-item__button-element')}>
                <Button
                    data-testid={`${id}-file-remove`}
                    variant='link'
                    onClick={onRemove}
                >
                    Remove file
                </Button>
            </div>
        </UploadedItemContainer>
    )
}
